import ProductWarnings from 'apps/products/models/ProductWarnings';

/**
 * Transforms object containing errors grouped by error type to an object containing errors grouped by SKUs.
 * Given:
 * {
 *   ITEM_UNAVAILABLE: [
 *     { sku: 1 },
 *     { sku: 2 },
 *   ]
 *   QUANTITY_PER_ITEM_EXCEEDED: [
 *     { sku: 1 },
 *   ]
 * }
 *
 * Will return:
 * {
 *   1: ['ITEM_UNAVAILABLE', 'QUANTITY_PER_ITEM_EXCEEDED'],
 *   2: ['ITEM_UNAVAILABLE'],
 * }
 */
export const createListOfErrorsPerSkuFromUpdateResultGroup = updateResults => (updateResults
  ? Object.keys(updateResults)
    .filter(key => key in ProductWarnings)
    .reduce((result, key) => {
      const group = updateResults[key];
      group.forEach(item => {
        const errorsForSku = result[item.sku] || [];
        errorsForSku.push(key);
        Object.assign(result, { [item.sku]: errorsForSku });
      });
      return result;
    }, {})
  : {}
);
